import { useMemo } from 'react';
import { useLocation } from 'react-router';

export const useAccessToken = () => {
  const location = useLocation();

  const accessToken = useMemo(() => {
    const tokenValue = new URLSearchParams(location.search).get('token');
    return tokenValue ?? '';
  }, [location.search]);

  const accessTokenQueryParam = useMemo(() => (accessToken ? `?token=${accessToken}` : ''), [accessToken]);

  return { accessToken, accessTokenQueryParam };
};

export default useAccessToken;
